import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { animatedInputFocus, animatedInputBlur } from 'lib/animated-input';

import Input from 'components/common/input';
import InputPopup from 'components/common/input/popup';


class InputText extends React.Component {
  constructor(props) {
    super(props);

    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
  }

  onFocus(e) {
    animatedInputFocus(this.props.value);
    // Dismiss error once user acknowledges
    if (this.props.error) { this.props.dismissError(this.props.value); }
  }

  onBlur(e) {
    animatedInputBlur(this.props.value);
  }

  onChange(e) {
    this.props.onChange(this.props.value, e);
  }

  render() {
    const classNames = cx({
      'animated-input': true,
      'input-error': this.props.error ? true : false
    });

    return(
      <div className={classNames} >
        {
          this.props.error
          ? <InputPopup message={this.props.error} />
          : null
        }
        <Input
          value={this.props.value}
          onBlur={this.onBlur}
          onChange={this.onChange}
          onFocus={this.onFocus}
          initialValue={this.props.initialValue}
        />
        <label className="h5-sg text-weight-light">
          <span>{this.props.display}</span>
        </label>
      </div>
    );
  }
}

InputText.propTypes = {
  // Props
  display:  PropTypes.string,
  error:  PropTypes.string,
  value:  PropTypes.string,
  initialValue:  PropTypes.string,
  // Functions
  dismissError:  PropTypes.func,
  onChange:  PropTypes.func,
};

InputText.defaultProps = {
  initialValue: '',
};

export default InputText;
